import { testId } from '../../utils';
import { PropsUnion } from '@blurb/utils';
import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  'data-testid': string;
}

export const Card: React.FC<
  PropsUnion<React.ComponentPropsWithRef<'div'>, CardProps>
> = ({ children, 'data-testid': dataTestId }) => {
  return (
    <div {...testId(dataTestId, 'card')} className="shadow rounded bg-white">
      {children}
    </div>
  );
};
